import React, { useEffect, useState } from 'react';
import { func, string } from 'prop-types';

import makeStyles from '@material-ui/core/styles/makeStyles';

import { useError } from '@avon/component-library';
import { Box, Typography } from '@material-ui/core';
import { getTC } from '../../utils/api/endpoints';

import { isMobile } from '../../utils/getDeviceType';

const useStyles = makeStyles(() => ({
  bodyToast: {
    backgroundColor: '#181818',
    display: 'flex',
    alignItems: 'center',
    position: 'fixed',
    width: '100%',
    height: 48,
  },
}));

const TC = ({ callApi, type, redirectTo }) => {
  const classes = useStyles();

  const { setError, cleanToastBanner } = useError();
  const [content, setContent] = useState();

  const [bodyToastShow, setBodyToastShow] = useState(true);
  const toggleBodyToast = () => setBodyToastShow(!bodyToastShow);

  const mobileCloseSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.6129 6.2097C7.22061 5.90468 6.65338 5.93241 6.29289 6.29289C5.90237 6.68342 5.90237 7.31658 6.29289 7.70711L10.5858 12L6.29289 16.2929L6.2097 16.3871C5.90468 16.7794 5.93241 17.3466 6.29289 17.7071C6.68342 18.0976 7.31658 18.0976 7.70711 17.7071L12 13.4142L16.2929 17.7071L16.3871 17.7903C16.7794 18.0953 17.3466 18.0676 17.7071 17.7071C18.0976 17.3166 18.0976 16.6834 17.7071 16.2929L13.4142 12L17.7071 7.70711L17.7903 7.6129C18.0953 7.22061 18.0676 6.65338 17.7071 6.29289C17.3166 5.90237 16.6834 5.90237 16.2929 6.29289L12 10.5858L7.70711 6.29289L7.6129 6.2097Z" fill="#181818" />
    </svg>
  );

  const infoIconSvg = (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M22.5 12C22.5 6.47715 18.0228 2 12.5 2C6.97715 2 2.5 6.47715 2.5 12C2.5 17.5228 6.97715 22 12.5 22C18.0228 22 22.5 17.5228 22.5 12ZM12.5 17C13.0128 17 13.4355 16.614 13.4933 16.1166L13.5 16V11C13.5 10.4477 13.0523 10 12.5 10C11.9872 10 11.5645 10.386 11.5067 10.8834L11.5 11V16C11.5 16.5523 11.9477 17 12.5 17ZM12.5 7C13.0523 7 13.5 7.44771 13.5 8C13.5 8.55229 13.0523 9 12.5 9C11.9477 9 11.5 8.55229 11.5 8C11.5 7.44771 11.9477 7 12.5 7Z" fill="white" />
    </svg>
  );

  const closeIconSvg = (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M8.1129 6.2097C7.72061 5.90468 7.15338 5.93241 6.79289 6.29289C6.40237 6.68342 6.40237 7.31658 6.79289 7.70711L11.0858 12L6.79289 16.2929L6.7097 16.3871C6.40468 16.7794 6.43241 17.3466 6.79289 17.7071C7.18342 18.0976 7.81658 18.0976 8.20711 17.7071L12.5 13.4142L16.7929 17.7071L16.8871 17.7903C17.2794 18.0953 17.8466 18.0676 18.2071 17.7071C18.5976 17.3166 18.5976 16.6834 18.2071 16.2929L13.9142 12L18.2071 7.70711L18.2903 7.6129C18.5953 7.22061 18.5676 6.65338 18.2071 6.29289C17.8166 5.90237 17.1834 5.90237 16.7929 6.29289L12.5 10.5858L8.20711 6.29289L8.1129 6.2097Z" fill="white" />
    </svg>
  );

  useEffect(() => {
    const getContent = async () => {
      try {
        // get help & support content
        await callApi(getTC(type)).then((res) => {
          setContent(res.jsonObject.legalInfo[0]);
        });

        cleanToastBanner();
        return true;
      } catch (e) {
        setError(e.error);
        return false;
      }
    };

    getContent();
  }, []);

  return (
    <>
      {isMobile() && bodyToastShow ? (
        <Box className={classes.bodyToast}>
          <Box m="12px 10px 12px 20px">{infoIconSvg}</Box>
          <Box>
            <Typography style={{
              color: '#FFFFFF', fontSize: 14, fontWeight: '500', fontFamily: 'Montserrat',
            }}
            >
              {content && content.tipLabel}
            </Typography>
          </Box>
          <Box
            style={{
              position: 'absolute',
              right: 20,
            }}
            onClick={toggleBodyToast}
          >
            {closeIconSvg}
          </Box>
        </Box>
      ) : null}
      {isMobile() && (
      <Box
        ml={3}
        style={{ width: 24, height: 24 }}
        onClick={() => {
          redirectTo({
            type: 'home', subType: null, hasFooter: false, params: null,
          });
        }}
      >
        {mobileCloseSvg}
      </Box>
      )}
      <Box
        m="24px"
        pb={4}
        textAlign="justify"
        dangerouslySetInnerHTML={{ __html: content && content.content.tcText }}
      />
    </>
  );
};

TC.propTypes = {
  callApi: func.isRequired,
  type: string.isRequired,
  redirectTo: func.isRequired,
};

export default TC;
